import restTypes from '../util/rest/types';
import restStates from '../util/rest/states';
import restInitState from '../util/rest/initState';
import { defaultPagination } from '../util/defaultData';

import {
  PREVIEW_CATEGORY_SET_CATEGORY_FIELDS,
  PREVIEW_CATEGORY_SET_PRODUCT_CATEGORIES_ATTRIBUTES,
  PREVIEW_CATEGORY_SET_ATTRIBUTES_MATRIX_ATTRIBUTES,
  PREVIEW_CATEGORY_SET_FILTERS,
  PREVIEW_CATEGORY_SET_FILTERS_ERRORS,
  PREVIEW_CATEGORY_SET_PRODUCTS_NIN_IDS,
  PREVIEW_CATEGORY_SET_PRODUCTS_IN_IDS,
  PREVIEW_CATEGORY_SET_SELECTED_PRODUCT_LIST,
  PREVIEW_CATEGORY_UPDATE_LOADED_PRODUCTS_IN,
  PREVIEW_CATEGORY_UPDATE_LOADED_PRODUCTS_NIN,
  PREVIEW_CATEGORY_COMPLETE_PRODUCTS_LIST_START,
  PREVIEW_CATEGORY_COMPLETE_PRODUCTS_LIST_FINISHED,
  PREVIEW_CATEGORY_SET_IS_APPLY_FILTER_ACTIVE,
  PREVIEW_CATEGORY_SET_IS_SWITCH_ON,
  PREVIEW_CATEGORY_SET_PRODUCT_FILTER,
  PREVIEW_CATEGORY_FETCH_PRODUCT_LIST_START,
  PREVIEW_CATEGORY_FETCH_PRODUCT_LIST_FINISHED,
  PREVIEW_CATEGORY_SET_PRODUCT_COMPOUND_QUERY,
  PREVIEW_CATEGORY_SET_LEFT_SIDE_PAGINATION,
  PREVIEW_CATEGORY_FETCH_PRODUCTS_BY_IDS_START,
  PREVIEW_CATEGORY_FETCH_PRODUCTS_BY_IDS_FINISHED,
  PREVIEW_CATEGORY_SET_SHOW_CATEGORIES_DIALOG,
  PREVIEW_CATEGORY_SET_MAPPED_CATEGORIES,
  PREVIEW_CATEGORY_SET_SELECTED_CATEGORIES,
  PREVIEW_CATEGORY_SET_PHYSICAL_CATEGORY_SEARCH_QUERY,
  PREVIEW_CATEGORY_SET_SELECTED_DIALOG_CATEGORIES,
  PREVIEW_CATEGORY_CLEAR_CATEGORY_PRODUCT_STATE,
  PREVIEW_CATEGORY_SET_RANKING_RULE_CODE,
  PREVIEW_CATEGORY_SET_SORTING_ERRORS,
  PREVIEW_CATEGORY_SET_SORT_RULES,
  PREVIEW_CATEGORY_SET_FACETS,
  PREVIEW_CATEGORY_SET_IS_DATA_CHANGED,
  PREVIEW_CATEGORY_SET_IS_CATEGORY_SAVING,
  PREVIEW_CATEGORY_SET_ERRORS,
} from '../actions/types';

const initialState = {
  originalItem: {},
  drawerState: {
    isOpen: false,
  },
  filter: {
    filters: [],
    filtersErrors: [],
    productFilter: [],
    isSwitchOn: false,
    productCategoriesAttributes: [{
      code: 'id',
      frontendInputType: 'selectProductsButton',
      id: 'attr_iHeYyv1MRdm1mG',
      isFilterable: true,
      isRequired: false,
      isSearchable: false,
      isSortable: false,
      isVariation: false,
      label: 'Products',
      value: 'id',
    }],
    attributesMatrixAttributes: [],
    product: {
      list: [],
      selectedProductList: { in: [], nin: [] },
      productsInIds: [],
      productsNotInIds: [],
      productsByIdsForIn: [],
      productsByIdsForNin: [],
      compoundSearch: { value: '' },
      leftSidePagination: defaultPagination,
      isProductDialogApplyFilterActive: false,
      categoryFetchProductListStart: false,
      categoryFetchProductListFinished: false,
      fetchProductsByIdsStarted: false,
      fetchProductsByIdsFinished: false,
    },
    category: {
      showSelectCategoriesDialog: false,
      mappedCategories: [],
      selectedCategories: [],
      selectedDialogCategories: [],
      physicalCategorySearchQuery: '',
    },
  },
  sort: {
    rankingRuleCode: null,
    sortingsErrors: [],
    sortRules: [],
  },
  facet: {
    facets: [],
  },
  isDataChanged: false,
  isCategorySaving: false,
  errors: [],
};
const previewCategoryRestTypes = restTypes('preview-category');
const {
  fetchOneStart,
  fetchOneFinished,
  updateStart,
  updateFinished,
  clearFromStateFinished,
} = previewCategoryRestTypes;

export default (state = { ...restInitState, ...initialState }, action = {}) => {
  switch (action.type) {
    case fetchOneStart:
      return {
        ...state,
        ...restStates.fetchOneStart,
      };
    case fetchOneFinished:
      return {
        ...state,
        ...restStates.fetchOneFinished,
        ...action.payload,
      };
    case updateStart:
      return {
        ...state,
        ...restStates.updateStart,
        ...action.payload,
      };
    case updateFinished:
      return {
        ...state,
        ...restStates.updateFinished,
        ...action.payload,
      };
    case PREVIEW_CATEGORY_SET_CATEGORY_FIELDS:
      return {
        ...state,
        ...action.payload,
      };
    case clearFromStateFinished:
      return {
        ...state,
        ...restStates.clearFromStateFinished,
        ...action.payload,
      };

    case PREVIEW_CATEGORY_SET_IS_DATA_CHANGED:
    case PREVIEW_CATEGORY_SET_IS_CATEGORY_SAVING:
    case PREVIEW_CATEGORY_SET_ERRORS:
      return {
        ...state,
        ...action.payload,
      };

    case PREVIEW_CATEGORY_SET_PRODUCT_CATEGORIES_ATTRIBUTES:
    case PREVIEW_CATEGORY_SET_ATTRIBUTES_MATRIX_ATTRIBUTES:
    case PREVIEW_CATEGORY_SET_FILTERS:
    case PREVIEW_CATEGORY_SET_FILTERS_ERRORS:
    case PREVIEW_CATEGORY_SET_IS_SWITCH_ON:
    case PREVIEW_CATEGORY_SET_PRODUCT_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.payload,
        },
      };

    case PREVIEW_CATEGORY_SET_PRODUCTS_NIN_IDS:
    case PREVIEW_CATEGORY_SET_PRODUCTS_IN_IDS:
    case PREVIEW_CATEGORY_SET_SELECTED_PRODUCT_LIST:
    case PREVIEW_CATEGORY_UPDATE_LOADED_PRODUCTS_IN:
    case PREVIEW_CATEGORY_UPDATE_LOADED_PRODUCTS_NIN:
    case PREVIEW_CATEGORY_COMPLETE_PRODUCTS_LIST_START:
    case PREVIEW_CATEGORY_COMPLETE_PRODUCTS_LIST_FINISHED:
    case PREVIEW_CATEGORY_SET_IS_APPLY_FILTER_ACTIVE:
    case PREVIEW_CATEGORY_FETCH_PRODUCT_LIST_START:
    case PREVIEW_CATEGORY_FETCH_PRODUCT_LIST_FINISHED:
    case PREVIEW_CATEGORY_SET_PRODUCT_COMPOUND_QUERY:
    case PREVIEW_CATEGORY_SET_LEFT_SIDE_PAGINATION:
    case PREVIEW_CATEGORY_FETCH_PRODUCTS_BY_IDS_START:
    case PREVIEW_CATEGORY_FETCH_PRODUCTS_BY_IDS_FINISHED:
      return {
        ...state,
        filter: {
          ...state.filter,
          product: {
            ...state.filter.product,
            ...action.payload,
          },
        },
      };

    case PREVIEW_CATEGORY_SET_SHOW_CATEGORIES_DIALOG:
    case PREVIEW_CATEGORY_SET_MAPPED_CATEGORIES:
    case PREVIEW_CATEGORY_SET_SELECTED_CATEGORIES:
    case PREVIEW_CATEGORY_SET_PHYSICAL_CATEGORY_SEARCH_QUERY:
    case PREVIEW_CATEGORY_SET_SELECTED_DIALOG_CATEGORIES:
      return {
        ...state,
        filter: {
          ...state.filter,
          category: {
            ...state.filter.category,
            ...action.payload,
          },
        },
      };

    case PREVIEW_CATEGORY_SET_RANKING_RULE_CODE:
    case PREVIEW_CATEGORY_SET_SORTING_ERRORS:
    case PREVIEW_CATEGORY_SET_SORT_RULES:
      return {
        ...state,
        sort: {
          ...state.sort,
          ...action.payload,
        },
      };

    case PREVIEW_CATEGORY_CLEAR_CATEGORY_PRODUCT_STATE:
      return {
        ...state,
        filter: {
          ...state.filter,
          product: {
            ...initialState.filter.product,
          },
        },
      };

    case PREVIEW_CATEGORY_SET_FACETS:
      return {
        ...state,
        facet: {
          ...state.facet,
          ...action.payload,
        },
      };

    default: return state;
  }
};
